<template>
  <div class="wl_company">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          :model="searchForm"
          label-width="90px"
          style="display: flex; height: 39px"
          label-position="left"
        >
          <el-form-item label="单位名称:">
            <el-input
              v-model="searchForm.dwmc"
              clearable
              placeholder="请输入单位名称"
            />
          </el-form-item>
          <el-form-item label-width="95px" label="法人/经营者:">
            <el-input
              v-model="searchForm.frmc"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
          <!-- <el-form-item label="业务类型:">
            <el-select clearable v-model="searchForm.ywlx" placeholder="请选择">
              <el-option label="生产" value="1"></el-option>
              <el-option label="使用" value="2"></el-option>
              <el-option label="经营" value="3"></el-option>
              <el-option label="运输" value="4"></el-option>
            </el-select>
          </el-form-item> -->
          <el-button
            v-preventReClick
            type="primary"
            icon="el-icon-search"
            round
            class="sousuoButton"
            @click="sousuo"
          >搜索</el-button>
        </el-form>
      </div>
    </div>
    <div
      style="
        width: 95%;
        max-width: 1518px;
        margin: 0 auto;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;
        margin: 0 auto;
      "
    >
      <div class="tablemes">
        <el-table
          ref="cktable"
          v-loading="loading"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
          @select="select"
        >
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <el-button
                v-preventReClick
                type="primary"
                class="addButton"
                size="mini"
                icon="el-icon-plus"
                @click="addPupShow"
              >添加</el-button>
              <el-button
                v-preventReClick
                size="mini"
                icon="el-icon-upload"
                @click="Daochu"
              >导出</el-button>
            </template>
            <el-table-column
              align="center"
              type="selection"
              width="55"
            />

            <el-table-column
              v-for="(item, i) in table"
              :key="i"
              align="center"
              :label="item.label"
              prop="cjsj"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span
                  v-if="item.key == 'sfyrw'"
                  :style="
                    scope.row[item.key] == '已入网'
                      ? { color: 'green' }
                      : { color: 'red' }
                  "
                  size="medium"
                >
                  {{ scope.row[item.key] }}
                </span>
                <span v-else size="medium" :title="scope.row[item.key]">
                  {{ scope.row[item.key] }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180px">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.glrwdwId"
                  v-preventReClick
                  class="editButton"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  v-preventReClick
                  class="deleteButton"
                  size="mini"
                  icon="el-icon-delete"
                  type="warning"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager,next,jumper,total,sizes"
          :page-sizes="[10, 20, 30, 40]"
          :total="total"
          :page-size="pagesize"
          class="el-page"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <wlCompanyPupVue
      ref="wlCompany"
      :type="leixing"
      :content="titleText"
    />
  </div>
</template>
<script>
import wlCompanyPupVue from './wlCompanyPup.vue'
import { getWldwList, remove, excelwriter } from '@/assets/js/wldw.js'
export default {
  components: { wlCompanyPupVue },
  props: {},
  data() {
    return {
      loading: true,
      leixing: '',
      titleText: '',
      dialogVisible: false,
      table: [
        {
          key: 'dwmc',
          label: '单位名称'
        },
        {
          key: 'shtyxydm',
          label: '统一社会信用代码'
        },
        {
          key: 'dwdz',
          label: '单位地址'
        },
        {
          key: 'frmc',
          label: '法人/经营者'
        },

        {
          key: 'sfyrw',
          label: '状态'
        },
        {
          key: 'cjsj',
          label: '创建日期'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      searchForm: {
        dwmc: '',
        frmc: '',
        ywlx: ''
      },

      multipleSelection: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getTableData()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    Daochu() {
      excelwriter(this.searchForm).then((e) => {
        const table = '往来单位'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    select(row) {
      console.log(row)
    },
    sousuo() {
      this.currentPage = 1
      this.getTableData(this.searchForm)
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getTableData()
    },
    // 页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.getTableData()
    },
    toggleSelection(rows) {},
    handleSelectionChange(val) {},
    // 点击新增时
    addPupShow() {
      this.leixing = 'add'
      this.titleText = '新增往来单位'
      this.$refs.wlCompany.dialogVisible = true
      this.$refs.wlCompany.form = {}
    },
    // 点击编辑时
    handleEdit(index, row) {
      this.leixing = 'edit'
      this.titleText = '编辑往来单位'
      this.$refs.wlCompany.queryDwById(row.id)
    },
    // 点击删除时
    handleDelete(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          remove(row.id).then((e) => {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success'
            })
            this.getTableData()
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },

    // 获取列表内容
    getTableData(data) {
      getWldwList({
        page: this.currentPage,
        size: this.pagesize,
        param: data
      }).then((e) => {
        this.loading = false
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: middle !important;
}
/deep/.el-table--border {
  border-right: none;
  border-bottom: none;
  z-index: 0 !important;
}
.wl_company {
  .headerSearch {
    width: 95%;
    max-width: 1518px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 27px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      // border-radius: 3px;
      border-color: #4170ff;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .addButton {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .yijiao {
      background-color: #4ca89d;
      border-color: #4ca89d;
      border-radius: 3px;
      color: white;
    }
    .editButton {
      padding: 0;
      color: #fff;
      width: 59px;
      height: 26px;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .deleteButton {
      padding: 0;
      color: #fff;
      width: 59px;
      height: 26px;
      background: #fe5622;
      border-radius: 3px;
      border-color: #fe5622;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
    /deep/.el-table-column--selection .cell {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
.el-form {
  .el-form-item:nth-child(1) {
    margin-right: 30px;
  }
  .el-form-item:nth-child(2) {
    margin-right: 30px;
  }
  .el-form-item {
    margin: 0;
    .el-form--inline .el-form-item__content {
      display: inline-block;
      // vertical-align: top;
      vertical-align: auto;
    }
  }
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #ebeef5;
  text-align: center;
}

.el-page {
  // width: 90px;
  // height: 39px;
  .el-pager {
    .active {
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
  }
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
